import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavComponent } from './nav/nav.component';
import { ReactiveFormsModule} from '@angular/forms';
import { AboutComponent } from './about/about.component';
import { ToolboxComponent } from './toolbox/toolbox.component'
import { MaterialComponent } from './material/material.component';
import { ProfileComponent } from './profile/profile.component';
import { MessageComponent } from './message/message.component';
import { PostComponent } from './post/post.component';
import { QuillModule} from 'ngx-quill'
// Import the module from the SDK
import { AuthModule, AuthService } from '@auth0/auth0-angular';
import { MainComponent } from './main/main.component';
import { IntroComponent } from './intro/intro.component';
import { EditorComponent } from './editor/editor.component';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireModule } from '@angular/fire';
import { StoreComponent } from './store/store.component';
import { CategoryComponent } from './category/category.component';
import { ItemComponent } from './item/item.component';
import { MapComponent } from './map/map.component';
import { DetailsComponent } from './details/details.component';
import { ApiService } from './api.service'
import { HttpClientModule } from '@angular/common/http';
import { ContactComponent } from './contact/contact.component';
@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    AboutComponent,
    ToolboxComponent,
    MaterialComponent,
    ProfileComponent,
    MessageComponent,
    PostComponent,
    MainComponent,
    IntroComponent,
    EditorComponent,
    StoreComponent,
    CategoryComponent,
    ContactComponent,
    ItemComponent,
    MapComponent,
    DetailsComponent,
    ],
  imports: [
    BrowserModule,
        // Import the module into the application, with configuration
    AppRoutingModule,
    ReactiveFormsModule,
    AngularFireStorageModule,
    AngularFireModule.initializeApp({
      apiKey: "AIzaSyBnPPqZgnRu1Mv4rQv9o2MWSPqpXE7a3kc",
      authDomain: "excess-material.firebaseapp.com",
      projectId: "excess-material",
      storageBucket: "excess-material.appspot.com",
      messagingSenderId: "854616127187",
      appId: "1:854616127187:web:b9ffd502664c5268adc626",
      measurementId: "G-ENH80SDJZK"
    }),
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons      
          [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      
          ['link'],          // dropdown with defaults from theme
        ],
      }
    }) ,
    HttpClientModule,
    AuthModule.forRoot({
      domain: 'leviapp.us.auth0.com',
      clientId: '7do0L9YgH2D1trRAIM2PNAN5B6Md7QLs'
    }),  
  ],
  providers: [AuthService, ApiService],
  bootstrap: [AppComponent]
})
export class AppModule { }
